import { createSelector } from '@reduxjs/toolkit';

import { selectSummarizedExams } from 'FRONTEND/selectors/consultationSelectors';

export const selectSummarizedWorkflowExams = createSelector(
  (_, workflow) => workflow,
  selectSummarizedExams,
  (workflow, summarizedExams) => {
    const summarizedCreateWorkflowExams = workflow?.transitions?.create?.exams_full.filter(exam => summarizedExams?.[exam.id]) || [];
    const summarizedCloseWorkflowExams = workflow?.transitions?.close?.exams_full.filter(exam => summarizedExams?.[exam.id]) || [];

    const summarizedWorkflowExams = [
      ...summarizedCreateWorkflowExams,
      ...summarizedCloseWorkflowExams,
      // Append more if needed.
    ];

    const orderedSummarizedWorkflowExams = Object.values(summarizedWorkflowExams).sort((a, b) => {
      const orderA = a.order ?? Infinity;
      const orderB = b.order ?? Infinity;
      return orderA - orderB;
    });
    return orderedSummarizedWorkflowExams;
  },
);

export const selectConsultationExamForm = createSelector(
  (_, workflow) => workflow,
  (_, __, examId) => examId,
  (workflow, examId) => {
    return workflow?.transitions?.create.exams_full.find((exam) => exam.id === examId);
  },
);

// Like selectConsultationExamForm but also appends extraFields defined on the surveillanceExam of the parent exam.
export const selectConsultationExamFormWithExtraFields = createSelector(
  (_, workflow) => workflow,
  (_, __, examId) => examId,
  (workflow, examId) => {
    const allExams = workflow?.transitions?.create?.exams_full ?? [];
    const surveillanceForm = allExams.find((exam) => exam.id === examId);
    if (!surveillanceForm) {
      return null;
    }

    const parentExam = allExams.find((exam) =>
      exam.surveillanceExams?.some((se) => se.id === examId),
    );

    const surveillanceExamForId = parentExam?.surveillanceExams?.find(
      (se) => se.id === examId,
    );


    if (!surveillanceExamForId?.extraFields?.length) {
      return surveillanceForm;
    }

    return {
      ...surveillanceForm,
      pages: [...surveillanceForm.pages, { fields: surveillanceExamForId.extraFields }],
    };
  },
);
